import styled from '@emotion/styled';
import React from 'react';
import { ThemeProps } from '@theme/base';

export const SeparatorStyle = styled.div(({ theme }: ThemeProps) => ({
  position: 'absolute',
  width: '100%',
  left: 0,
  height: 1,
  backgroundColor: theme.custom.colors.group10.light
}));

/*
 * An absolute positioned section separator that renders the full width of the screen
 */

export interface SeparatorProps {
  className?: string;
}

export const Separator = ({ className }: SeparatorProps) => <SeparatorStyle className={className} />;
